import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { MAX_ADDITIONAL_INFO } from '../../common/constant'
import { Currency } from './Currency'
import classes from './index.module.scss'

export const Header = () => {
  return (
    <Element className={classes.header} style={{ backgroundColor: '#D5D5D5' }}>
      <Element style={{ fontSize: 14 }}>
        <Translate value="screening.SELECTED_CRITERIA" />
      </Element>
      <Element style={{ fontSize: 14 }}>
        <Translate value="screening.ADD_INFO_TO_VIEW" />
      </Element>
      <Element className="dFlex justifyContentBetween alignItemsStart">
        <Element className="dFlex flexWrap alignItemsEnd">
          <Element className={classes.mr4} style={{ fontSize: 14 }}>
            <Translate value="screening.TOTAL_INFORMATION" />
          </Element>
          <Element
            className={classes.subTitle}
            style={{ fontSize: 12, color: '#3A414B' }}
          >
            <Translate
              value="screening.ADD_MAX_INFORMATION"
              max={MAX_ADDITIONAL_INFO}
            />
          </Element>
        </Element>

        <Currency />
      </Element>
    </Element>
  )
}
